import Vue from 'vue'
import constants from '@core/utils/constants'

Vue.prototype.$constants = constants
